import moment from "moment";
import { notification } from "antd";
import _ from "lodash";

// declare global perPage value for listing view
export const perPage = 10;

/**
 * @function calculateDob
 * @param date
 * @desc this function will return the dob
 */
export const calculateDob = date => moment().diff(moment(date), "years");

/**
 * @function formatedDate1
 * @param date
 * @desc this function will return the dob ("12 Aug, 2018")
 */
export const formatedDate1 = date => moment(date).format("DD MMM, YYYY");

/**
 * @function formatedRelativeTime
 * @param date
 * @desc this function will return the relative time (4 minutes)
 */
export const formatedRelativeTime = date => moment(date).fromNow(true);

/**
 * @function formatedTime
 * @param date
 * @desc this function will formated time (05:40 PM)
 */
export const formatedTime = date => moment(date).format("hh :mm A");

/**
 * @function scrollToTabTopRef
 * @param referencePoint
 * @desc this function will scroll view to a reference point on DOM
 */
export const scrollToTabTopRef = refPoint => {
  // run this method to execute scrolling.
  window.scrollTo({
    top: refPoint.current.offsetTop,
    behavior: "smooth" // Optional, adds animation
  });
};

export const openNotificationWithIcon = (type, title, description) => {
  notification.destroy();
  notification[type]({
    message: title,
    description
  });
};

/**
 * @function renameKeys
 * @param keysMap - which key to map with which
 * @param obj - object to map
 * @desc this function will return the dob
 */
export const renameKeys = (keysMap, obj) =>
  Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [keysMap[key] || key]: obj[key] }
    }),
    {}
  );

/** @function hideLeftNav
 * @desc - This will return true of false
 */
export const hideLeftNav = () => {
  const path = window.location.pathname.replace("/", "");
  let hideNav = false;
  switch (path) {
    case "sign-in":
      hideNav = true;
      break;
    default:
      hideNav = false;
  }
  return hideNav;
};

/**
 * @function getProp
 * @param {*} p
 * @desc it will get the data string from the repsonse
 */
export const getProp = p => o =>
  p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);

/**
 * @function downloadImageFromurl
 * @param url
 * @param fileName
 * @desc it download Image from url
 */
export const downloadImageFromurl = (url, fileName) => {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(this.response);
    const tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
};

/**
 * @function replaceWith
 * @param text
 * @desc it will replace strings
 */
export const replaceWith = (text, from, to) => {
  return text.replace(from, to);
};

export const newsTypes = ["NEWS", "COVID19", "JOB", "JOURNAL", "PHARMA", "CME", "kulcare_social"];

/**
 * @function parsePlace
 * @param addressComponents
 * @desc This function handles fetching state and city from
 * location selected from the google place dropdown
 */
export const parsePlace = addressComponents => {
  const parsedResult = {};
  for (let i = 0; i < addressComponents.length; i++) {
    for (let b = 0; b < addressComponents[i].types.length; b++) {
      if (addressComponents[i].types[b] === "locality") {
        // this is the object you are looking for city
        parsedResult.city = addressComponents[i].long_name;
        break;
      } else if (
        addressComponents[i].types[b] === "administrative_area_level_1"
      ) {
        // this is the object you are looking for state
        parsedResult.state = addressComponents[i].long_name;
        break;
      }
    }
  }
  return parsedResult;
};

/**
 * @function generateLocationString
 * @desc This function returns location as comma seperate string
 */
export const generateLocationString = location => {
  let loc = [];
  if (location && !_.isEmpty(location)) {
    if (location.address_line_1 && location.address_line_1 !== "")
      loc.push(location.address_line_1);
    if (location.address_line_2 && location.address_line_2 !== "")
      loc.push(location.address_line_2);
    if (location.city && location.city !== "") loc.push(location.city);
    if (location.state && location.state !== "") loc.push(location.state);
  }

  return loc.join(", ");
};

/** *
 * @function keyLocallyPresentInStorage
 * @param key
 * @desc This method checks if value presents
 * in local storage or session storage
 */
export const keyLocallyPresentInStorage = key => {
  const keyPresent =
    localStorage.getItem(key) &&
    localStorage.getItem(key) != "undefined" &&
    localStorage.getItem(key) !== null &&
    localStorage.getItem(key) !== "null";
  return keyPresent;
};

export const bytesToSize = bytes => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  return `${Math.round(bytes / Math.pow(1024, i), 2)}${sizes[i]}`;
};
